import React from 'react';
import { Youtube, Play, Instagram } from 'lucide-react';
import { socialLinks } from '../data/mockData';

const FreeContentSection = () => {
  // IDs reais dos vídeos do canal
  const videoIds = [
    'Dfx7jVHBxeg',
    'kZmvsBCDr48',
    '1Hp3u2QjRSg'
  ];

  return (
    <section id="conteudo-gratuito" className="py-20 bg-gradient-to-b from-white to-gray-50">
      <div className="container mx-auto px-4">
        <div className="max-w-3xl mx-auto text-center mb-16">
          <div className="inline-block bg-red-100 text-red-600 px-4 py-2 rounded-full font-semibold mb-4">
            <Youtube className="inline-block mr-2" size={20} />
            100% Gratuito
          </div>
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
            Aprenda <span className="text-orange-500">Gratuitamente</span> Todos os Dias
          </h2>
          <p className="text-xl text-gray-600">
            Acesse nosso canal no YouTube e Instagram com conteúdo diário de qualidade para acelerar seus estudos
          </p>
        </div>

        {/* Video Grid */}
        <div className="grid md:grid-cols-3 gap-6 max-w-6xl mx-auto mb-12">
          {videoIds.map((videoId, index) => (
            <div 
              key={index}
              className="group bg-white rounded-2xl shadow-lg overflow-hidden hover:shadow-2xl transition-all duration-300 transform hover:-translate-y-2"
            >
              <div className="relative aspect-video bg-gray-200">
                <iframe
                  className="w-full h-full"
                  src={`https://www.youtube.com/embed/${videoId}`}
                  title={`Vídeo ${index + 1}`}
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                  allowFullScreen
                ></iframe>
              </div>
              <div className="p-4">
                <p className="text-sm text-gray-600">
                  Aula gratuita {index + 1}
                </p>
              </div>
            </div>
          ))}
        </div>

        {/* CTA Cards */}
        <div className="grid md:grid-cols-2 gap-8 max-w-4xl mx-auto">
          {/* YouTube Card */}
          <a 
            href={socialLinks.youtube}
            target="_blank"
            rel="noopener noreferrer"
            className="group bg-gradient-to-br from-red-600 to-red-700 rounded-2xl p-8 text-white hover:shadow-2xl transition-all duration-300 transform hover:-translate-y-2"
          >
            <div className="flex items-center justify-between mb-6">
              <Youtube size={48} />
              <Play className="text-white/50 group-hover:text-white transition-colors" size={32} />
            </div>
            <h3 className="text-2xl font-bold mb-3">
              Aulas Completas no YouTube
            </h3>
            <p className="text-red-100 mb-6">
              Assista aulas gratuitas todos os dias e aprenda com didática simples e eficiente
            </p>
            <div className="inline-flex items-center space-x-2 bg-white/20 px-6 py-3 rounded-lg font-semibold group-hover:bg-white/30 transition-colors">
              <span>Acessar Canal</span>
              <Play size={20} />
            </div>
          </a>

          {/* Instagram Card */}
          <a 
            href={socialLinks.instagram}
            target="_blank"
            rel="noopener noreferrer"
            className="group bg-gradient-to-br from-purple-600 via-pink-600 to-orange-500 rounded-2xl p-8 text-white hover:shadow-2xl transition-all duration-300 transform hover:-translate-y-2"
          >
            <div className="flex items-center justify-between mb-6">
              <Instagram size={48} />
              <Play className="text-white/50 group-hover:text-white transition-colors" size={32} />
            </div>
            <h3 className="text-2xl font-bold mb-3">
              Dicas Rápidas no Instagram
            </h3>
            <p className="text-purple-100 mb-6">
              Acompanhe dicas diárias, resumos e motivação para manter seu foco na aprovação
            </p>
            <div className="inline-flex items-center space-x-2 bg-white/20 px-6 py-3 rounded-lg font-semibold group-hover:bg-white/30 transition-colors">
              <span>Seguir Agora</span>
              <Instagram size={20} />
            </div>
          </a>
        </div>

        {/* Bottom CTA */}
        <div className="mt-16 max-w-4xl mx-auto bg-gradient-to-r from-blue-900 to-blue-800 rounded-2xl p-8 md:p-12 text-white text-center shadow-2xl">
          <h3 className="text-3xl font-bold mb-4">
            Gostou do conteúdo gratuito?
          </h3>
          <p className="text-xl text-gray-200 mb-8">
            Imagine ter acesso aos flashcards completos para acelerar ainda mais seus estudos!
          </p>
          <button 
            onClick={() => {
              const element = document.getElementById('produtos');
              if (element) element.scrollIntoView({ behavior: 'smooth' });
            }}
            className="bg-orange-500 text-white px-8 py-4 rounded-lg font-bold text-lg hover:bg-orange-600 transition-all duration-300 transform hover:scale-105 shadow-lg"
          >
            Ver Flashcards com 50% OFF
          </button>
        </div>
      </div>
    </section>
  );
};

export default FreeContentSection;
